import { CRMTypes } from '@labrav/common'
import { snakeize } from 'casing'
import {
  postCloneReferralTemplate,
  postCloneTemplateSalesforce,
} from '../../../api/mappingManager'

export const cloneMarketplaceTemplateAPI = async ({
  crmId,
  templateId,
  templateData,
  crmType,
  accountId,
  useMappingService,
}: {
  crmId: string
  templateId: string
  crmType?: CRMTypes
  templateData: Record<string, string>
  accountId?: string
  useMappingService?: boolean
}) => {
  if (crmType === CRMTypes.salesforce || useMappingService) {
    return await postCloneTemplateSalesforce(
      crmId,
      accountId ?? '',
      snakeize(templateData)
    )
  }

  return await postCloneReferralTemplate(
    crmId,
    templateId,
    snakeize(templateData)
  )
}
